import {
  HeaderInitialStateType,
  MasterInitialStateType,
  OrganizationInitialStateType,
  PatientActionReturnType,
} from "DataTypes/Redux";
import {
  CLEAR_MASTER,
  CLEAR_HEADER,
  ADD_ORG,
  CLEAR_ORG,
  UPDATE_MASTER,
} from "./type";

const MasterInitialState: MasterInitialStateType = {
  categoryId: null,
  page: 1,
  limit: 25,
};

const OrganizationInitialState: OrganizationInitialStateType = {
  id: null,
  name: "",
  masterPractice: false,
  modelId: null,
  modelName: "",
};

const INITIAL_STATE: HeaderInitialStateType = {
  master: MasterInitialState,
  organization: OrganizationInitialState,
};

const reducer = (state = INITIAL_STATE, action: PatientActionReturnType) => {
  switch (action.type) {
    case UPDATE_MASTER:
      return {
        ...state,
        master: action.payload,
      };
    case CLEAR_MASTER:
      return {
        ...state,
        master: MasterInitialState,
      };
    case ADD_ORG:
      return {
        ...state,
        organization: action.payload,
      };
    case CLEAR_ORG:
      return {
        ...state,
        organization: OrganizationInitialState,
      };
    case CLEAR_HEADER:
      return {
        ...state,
        master: MasterInitialState,
        organization: OrganizationInitialState,
      };
    default:
      return state;
  }
};

export default reducer;
